import { MultilegComboType } from '@src/components/MultilegCombo/enums';
import { getMultilegInstrumentType } from '@src/components/OMS/NewOrder/utils/mappers';
import type { MixpanelEventSource } from '@talos/kyoko';
import { MixpanelEvent, MixpanelEventProperty, useCallbackRef, useMixpanel, type Security } from '@talos/kyoko';
import { useNavigateToMultilegCombo } from './useNavigateToMultilegCombo';

export function useCloneMultilegSymbol(source: MixpanelEventSource) {
  const navigateToMultilegCombo = useNavigateToMultilegCombo();
  const mixpanel = useMixpanel();

  const cloneMultilegSymbol = useCallbackRef((security: Security) => {
    const multilegInstrumentType =
      getMultilegInstrumentType(security?.MultilegDetails?.SyntheticProductType) ?? MultilegComboType.SyntheticCross;

    mixpanel.track(MixpanelEvent.CloneMultileg, {
      [MixpanelEventProperty.Source]: source,
    });

    navigateToMultilegCombo({ instrumentType: multilegInstrumentType, legSymbols: [security.Symbol], isClone: true });
  });

  return cloneMultilegSymbol;
}
